/* eslint-disable no-alert, no-console */
<template>
  <div class="refund-states">
    <h1 class="refund-states__title">Заявки на возврат</h1>
    <div>
      <div v-if="isLoadingOffers">
        <Skeleton
          class="order-cards__skeleton"
          width="100%"
          style="margintop: 15px"
          height="110px"
        />
        <Skeleton
          class="order-cards__skeleton"
          width="100%"
          style="margintop: 15px"
          height="110px"
        />
        <Skeleton
          class="order-cards__skeleton"
          width="100%"
          style="margintop: 15px"
          height="110px"
        />
      </div>
      <div
        v-else-if="this.offers == null || this.offers.length == 0"
        class="refund-states__nooffers"
      >
        <p>У вас нет заявок на возврат</p>
      </div>
      <div v-else>
        <div
          v-for="(offer, index) in this.offers"
          :key="index"
          class="refund-states__refund-item"
        >
          <router-link
            :to="{
              name: 'Offer',
              params: {
                offerId: offer.Id,
              },
            }"
            class="ticket-num__btn-options__change-link"
          >
            <div>
              <div class="refund-states__refund-item__number">
                <img
                  :src="require(`../assets/images/support-ticket.svg`)"
                  alt=""
                  class="refund-states__refund-item__icon"
                  title="Номер заявки"
                />
                <p>{{ "№ " + offer.Id }}</p>
              </div>
              <div class="refund-states__refund-item__date">
                <img
                  :src="require(`../assets/images/calendar.svg`)"
                  alt=""
                  class="refund-states__refund-item__icon"
                />
                <p>{{ getCreatedDate(offer.DateCreate) }}</p>
              </div>
              <div
                v-if="offer.StateId == 10 || offer.StateId == 20"
                class="refund-states__refund-item__status"
              >
                <div class="refund-states__refund-item__status-icon">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#F37E21" />
                  </svg>
                </div>
                <p>{{ getOfferStatus(offer.StateId) }}</p>
              </div>
              <div
                v-if="offer.StateId == 30"
                class="refund-states__refund-item__status"
              >
                <div class="refund-states__refund-item__status-icon">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#6BC242" />
                  </svg>
                </div>
                <p>{{ getOfferStatus(offer.StateId) }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import store from "../store";
import Skeleton from "primevue/skeleton";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "UserOffers",
  components: {
    Skeleton,
  },
  props: [],
  setup(props) {
    const isLoadingOffers = ref(false);
    const error = ref(null);
    const offers = ref(null);
    const router = useRouter();
    const route = useRoute();
    const getUserOffers = async () => {
      isLoadingOffers.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetUserOffers`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          offers.value = fetchedOrders.offersList;
          isLoadingOffers.value = false;
        } else {
          console.log("error!");
          isLoadingOffers.value = false;
        }

        isLoadingOffers.value = false;
        console.log(offers.value);
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      offers,
      getUserOffers,
      isLoadingOffers,
      error,
    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    getCreatedDate(date: any) {
      function pad(n: any) {
        return n < 10 ? "0" + n : n;
      }
      const now = new Date(date);
      const tz = now.getTimezoneOffset();
      const sign = tz > 0 ? "-" : "+";
      const hours = pad(Math.floor(Math.abs(tz) / 60));
      const minutes = pad(Math.abs(tz) % 60);
      const tzOffset = sign + hours + ":" + minutes;
      const localDateTime =
        now.getFullYear() +
        "-" +
        pad(now.getMonth() + 1) +
        "-" +
        pad(now.getDate()) +
        "T" +
        pad(now.getHours()) +
        ":" +
        pad(now.getMinutes()) +
        ":" +
        pad(now.getSeconds());
      const eventDate = {
        utc: now.toISOString(),
        local: localDateTime,
        tzOffset: tzOffset,
      };

      const localDateString = eventDate.local;
      const localDate = new Date(localDateString);

      let created: any = new Date(localDate);
      if (tz < 0) {
        created.setHours(
          created.getHours() - 10 + Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
      } else if (tz > 0) {
        created.setHours(
          created.getHours() - 10 - Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
      }

      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };

      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes() +
        " (UTC " +
        tzOffset +
        ")"
      );
    },
    getOfferStatus(num: number) {
      if (num == 10) {
        return "Заявка создана";
      } else if (num == 20) {
        return "Заявка в работе";
      } else if (num == 30) {
        return "Заявка обработана";
      } else if (num == 40) {
        return "Сообщение";
      }
    },
    getTicketStatus(num: number) {
      if (num == 1) {
        return "Заявка создана";
      } else if (num == 2) {
        return "Заявка в работе";
      } else if (num == 3) {
        return "Заявка успешно решена";
      } else if (num == 4) {
        return "Требуется обратная связь";
      } else if (num == 5) {
        return "Заявка закрыта";
      } else if (num == 6) {
        return "Отказ по заявке";
      }
    },
  },
  created() {
    this.getUserOffers();
  },
});
</script>

<style>
.refund-states__refund-item {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 10px;
  margin-top: 15px;
}

.refund-states__title {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  margin: 2px 0 0 20px;
}

.refund-states__nooffers {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 30px 10px 30px 20px;
  margin-top: 15px;
}

.refund-states__refund-item__number {
  display: flex;
  align-items: center;
}

.refund-states__refund-item__icon {
  width: 23px;
  height: 25px;
  margin-right: 10px;
}

.refund-states__refund-item__date {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.refund-states__refund-item__status {
  display: flex;
  margin-top: 10px;
}

.refund-states__refund-item__subject {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.refund-states__refund-item__status-icon {
  width: 23px;
  height: 25px;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-right: 10px;
}

.refund-states__tickets-title {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  margin: 20px 0 0 20px;
}
</style>
